const departamentoEhVazio = (value,vm) => !(vm.departamentoEhVazio.length == 0)

export const validateData = {
  departamentosSelecionados:{ departamentoEhVazio },
}

export const validateComputed = {
  
  departamentoErrors(){
    const errors = []
    if (!this.$v.departamentosSelecionados.$dirty) return errors
    !this.$v.departamentosSelecionados.departamentoEhVazio && errors.push('Departamento Vazio.')
    return errors
  },

}
